<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-treasure-level-config-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {TreasureLevelConfig} from "@/modules/redactor/models/smart-offer/bundle-treasure/TreasureLevelConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RTreasureLevelConfigTable from "@/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-level-config-table.vue";

export default {
  name: "r-treasure-level-config-panel",
  components: {RTreasureLevelConfigTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Treasure Level Config"),
    items: VueTypes.arrayOf(TreasureLevelConfig)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>